<template>
  <v-row>
    <v-col cols="6">
      <v-combobox
        id="input:marcaId"
        v-model="marcaId"
        :rules="[requiredRule]"
        :items="marcaIdOptions"
        :search-input.sync="search"
        :hide-no-data="!search"
        label="Nome da marca"
        :loading="loading"
        required
        outlined
        clearable
        v-bind="attrsMarca"
        @keyup.enter="createMarca()"
      >
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                Não encontrado
                "<strong>{{ search }}</strong>".
                Aperte <kbd>Enter</kbd> para criar
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-combobox>
    </v-col>
    <v-col cols="6">
      <input-select
        id="input:idRegionalMarca"
        v-model="payload.idRegionalMarca"
        :rules="[requiredRule]"
        :items="regionalMarcaOptions"
        label="Regional"
        :loading="regionalLoading"
        required
        outlined
        clearable
        disabled
        v-bind="attrsRegional"
      />
    </v-col>
  </v-row>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import RegionalRequest from 'Modules/contacard/produto/marca/regional/RegionalRequest';
import MarcaRequest from 'Modules/contacard/produto/marca/MarcaRequest';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';

export default {
  name: 'MarcaRegionalInput',
  mixins: [RulesMixin, RequestSelectMixin, ServiceMixin],
  props: {
    payload: {
      type: Object,
      default() {
        return {
          idRegionalMarca: '',
          id: '',
        };
      },
    },
    attrsMarca: {
      type: Object,
      default() {
        return {};
      },
    },
    attrsRegional: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    requestRegional: RegionalRequest,
    requestMarca: MarcaRequest,
    loading: false,
    regionalLoading: false,
    marcaId: '',
    search: null,
    regionalMarcaOptions: [],
    marcaIdOptions: [],
    marcaMessageError: 'Falha ao buscar marcas',
    regionalMessageError: 'Falha ao buscar regionais',
    getMarcaMessageError: 'Falha ao buscar marca!',
    getRegionalMessageError: 'Falha ao buscar marca!',
  }),
  computed: {
    disabledRegionalOptions() {
      return !this.regionalMarcaOptions.length;
    },
    regionalId() {
      return this.payload.idRegionalMarca;
    },
  },
  watch: {
    marcaId: {
      immediate: true,
      handler({ value }) {
        if (value) {
          this.handleRegionalLoading();
          this.getRegionalMarcaRequest(value);
        }
      },
    },
    regionalId: {
      immediate: true,
      handler(value) {
        if (!this.marcaId && value) {
          this.handleMarcaLoading();
          this.getMarcaId(value);
        }
      },
    },
  },
  created() {
    this.makeMarcaRequest();
  },
  methods: {
    makeMarcaRequest() {
      this.handleMarcaLoading();
      this.serviceCall(
        this.requestMarca.list(
          this.makeParams(),
        ),
        this.setDataOptions('marcaIdOptions', 'nomMarca'),
        this.marcaMessageError,
        this.handleMarcaLoading,
      );
    },
    handleRegionalLoading() {
      this.regionalLoading = !this.regionalLoading;
    },
    getRegionalMarcaRequest() {
      this.serviceCall(
        this.requestMarca.listRegionais(
          this.marcaId.value,
          this.makeParams(),
        ),
        this.setDataOptions('regionalMarcaOptions', 'nomRegional'),
        this.regionalMessageError,
        this.handleRegionalLoading,
      );
    },
    getMarcaId() {
      this.callService(
        this.requestMarca.getRegional(this.regionalId),
        this.getMarcaByRegional,
        this.makeSwalConfig(
          this.getRegionalMessageError,
        ),
      );
    },
    handleMarcaLoading() {
      this.loading = !this.loading;
    },
    getMarcaByRegional(response) {
      if (response && response.data && response.data.idMarca) {
        this.callService(
          this.requestMarca.get(response.data.idMarca),
          this.setMarcaId,
          this.makeSwalConfig(
            this.getMarcaMessageError,
          ),
        );
      }
    },
    setMarcaId(response) {
      this.handleMarcaLoading();
      if (response && response.data && response.data.id) {
        this.marcaId = {
          text: response.data.nomMarca,
          value: response.data.id,
        };
      }
    },
    makeSwalConfig(errorMessage) {
      return {
        errorMessage,
        showSuccessSwal: false,
        showErrorSwal: true,
      };
    },
    createMarca() {
      this.callService(
        this.requestMarca.save({
          nomMarca: this.search,
        }),
        this.successCreateCb,
      );
    },
    successCreateCb(response) {
      if (response && response.data) {
        this.makeMarcaRequest();
        this.marcaId = response.data.data;
      }
    },
  },
};
</script>
